import JetAccordionCollection from '@src/shared/components/JetAccordionCollection';
import React, { useEffect, useState } from 'react';
import ManagerFAQContentKeys from '../ManagerFAQContentKeys';
import CourierFAQContentKeys from '../CourierFAQContentKeys';
import { PAGE_TYPE } from '../../..';
import JetAccordion from '@src/shared/components/JetAccordion';
import { Typography } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import i18n from '@src/i18n';
import JetFontIcon, { JET_FONTICON_ALIASES } from '@src/shared/components/JetFontIcon';
import useStyles from './styles';
import { trackFAQClick as trackFAQClickManager } from '@src/pages/ProductOverview/tracking/page';
import { trackFAQClick as trackFAQClickCourier } from '@src/pages/CourierOverview/tracking/page';
const FAQListPaginated = ({pageType = PAGE_TYPE.MANAGER}) => {
  const [selectedFAQ, setSelectedFAQ] = useState(0);
  const [currentPage, setCurrentPage] = useState(1)
  const classes = useStyles();
  const questions =
  pageType === PAGE_TYPE.MANAGER
    ? ManagerFAQContentKeys
    : CourierFAQContentKeys;
  const pageCount = Math.ceil(questions.length / 3)
  const offsetStart = (currentPage * 3) - 3
  const { t } = useTranslation();
  const nextPage = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1)
    }
  }
  const previousPage = () => {
    if(currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  useEffect(()=> { 
    setSelectedFAQ(-1)
  },[currentPage])

  useEffect(()=> {
    setCurrentPage(1)
  }, [pageType])
   return  <>
      <span className={classes.pagingContainer}>
        <Typography
            variant="body1"
            className="body_regular pagingInnerContainer"
            align="right">
            <JetFontIcon className={`${currentPage === 1 ? 'disabled-paging' : ''}`} onClick={previousPage} iconname={JET_FONTICON_ALIASES.CHEVRON_LEFT} size={20} />
            {currentPage} of {pageCount}
            <JetFontIcon className={`${currentPage === pageCount ? 'disabled-paging' : ''}`} onClick={nextPage} iconname={JET_FONTICON_ALIASES.CHEVRON_RIGHT} size={20}  />
        </Typography>
      </span>
      <div className={classes.collectionContainer}>
      <JetAccordionCollection
        sharedValue={selectedFAQ}
        collectionName="faq_first_column"
        onAccordionItemSelected={(itemIndex,indexNumber) => {
          const calculatedItemIndex = ((currentPage * 3) - 3) + (indexNumber)
          setSelectedFAQ(itemIndex);
          if (calculatedItemIndex > -1) {
            const faqItem = questions[calculatedItemIndex]
            if (pageType === PAGE_TYPE.MANAGER) {
              trackFAQClickManager(t(faqItem.questionKey,{ lng: 'en'}), calculatedItemIndex)
            } else if (pageType === PAGE_TYPE.COURIER) {
              trackFAQClickCourier(t(faqItem.questionKey,{ lng: 'en'}), calculatedItemIndex)
            }
          }
        }}
      >
        {Array
          .from(questions)
          .splice(offsetStart,3)
          .map((FAQContent) => {
            return (
              <JetAccordion
                className={'faq-item'}
                newui={'true'}
                title={i18n.t(FAQContent.questionKey)}
                width={564}
              >
                <Typography
                  variant="body1"
                  className="body_regular"
                  align="left"
                >
                  <Trans i18nKey={FAQContent.answerKey} />
                </Typography>
              </JetAccordion>
            );
          })}
      </JetAccordionCollection>
      </div>
    </>
}

export default FAQListPaginated